import { USE_MOCK } from '@/lib/api/env';
import type { CallsApi } from './callsAdapter';
import { callsHttp } from './callsHttp';
import { callsMock } from './callsMock';

/**
 * LIVE by default — `/api/v1/calls` plus `call.incoming` / `call.cancelled` on
 * `user:<self>`. `VITE_USE_MOCK=true` restores the scripted ring.
 */
export const callsApi: CallsApi = USE_MOCK ? callsMock : callsHttp;
